import React from "react";

const About = () => {
  return (
    <div>
      <span style={{ height: "80vh" }} id="about">
        {" "}
        About
      </span>
    </div>
  );
};

export default About;
